(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/multi-image.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/multi-image.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$utils = svs.utils,
  clsvs = _svs$utils.clsvs,
  svsuid = _svs$utils.svsuid;
const _Handlebars$helpers = Handlebars.helpers,
  getNoscriptUrl = _Handlebars$helpers.getNoscriptUrl,
  getDefaultImgUrl = _Handlebars$helpers.getDefaultImgUrl,
  getUrlWithCorrectHost = _Handlebars$helpers.getUrlWithCorrectHost,
  getSourceElementsData = _Handlebars$helpers.getSourceElementsData,
  setStyleElement = _Handlebars$helpers.setStyleElement;
const config = {
  options: svs.core.config.data.svsconfig
};
const logger = new svs.core.log.Logger('image-v2:React_MultiImage');
const MultiImage = _ref => {
  let altText = _ref.altText,
    title = _ref.title,
    images = _ref.images,
    cssSelectors = _ref.cssSelectors,
    noscriptUrl = _ref.noscriptUrl,
    loadingLazy = _ref.loadingLazy,
    fitWrapper = _ref.fitWrapper,
    onLoadCallback = _ref.onLoadCallback,
    fallbackImage = _ref.fallbackImage;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasError = _useState2[0],
    setHasError = _useState2[1];
  const uniqueSelector = "image-".concat(svsuid());
  const $noscriptUrl = getNoscriptUrl(undefined, images, noscriptUrl, true);
  const defaultImgUrl = getDefaultImgUrl(undefined, images, undefined, true);
  const fallbackImageUrl = getUrlWithCorrectHost(fallbackImage, config);
  const _useState3 = useState(altText),
    _useState4 = _slicedToArray(_useState3, 2),
    currentAlt = _useState4[0],
    setCurrentAlt = _useState4[1];
  const _useState5 = useState(title),
    _useState6 = _slicedToArray(_useState5, 2),
    currentTitle = _useState6[0],
    setCurrentTitle = _useState6[1];
  const itemType = 'http://schema.org/ImageObject';
  const imageClassNames = clsvs('image-wrapper', uniqueSelector, fitWrapper && 'background-image-wrapper image-wrapper-fit', cssSelectors);
  const handleError = ev => {
    const currentTarget = ev.currentTarget;
    currentTarget.onerror = null;
    if (fallbackImage) {
      setHasError(true);
    } else {
      logger.warn("Failed to load image: ".concat(currentTarget.currentSrc));
    }
  };
  const handleImageLoad = ev => {
    const currentTarget = ev.currentTarget;
    const currentSrc = currentTarget.currentSrc;
    const imageArray = Object.values(images);
    const matchingImage = imageArray.find(img => {
      const urlToMatch = img.url.split('/').slice(-3).join('/');
      return currentSrc.includes(urlToMatch);
    });
    if (matchingImage) {
      setCurrentAlt(matchingImage.altText);
      setCurrentTitle(matchingImage.title);
    }
    if (onLoadCallback) {
      onLoadCallback(ev);
    }
  };
  useEffect(() => {
    setStyleElement(uniqueSelector, images);
  }, [images, uniqueSelector]);
  const Img = () => {
    const ImgSrc = hasError ? fallbackImageUrl : defaultImgUrl;
    return React.createElement("img", {
      alt: currentAlt,
      className: "js-image image",
      "data-fallback-image": hasError,
      decoding: "sync",
      itemProp: "image",
      loading: loadingLazy ? 'lazy' : 'eager',
      onLoad: handleImageLoad,
      src: ImgSrc,
      title: currentTitle
    });
  };
  const imagesArray = images ? Object.values(images) : [];
  return React.createElement("div", {
    className: imageClassNames,
    "data-is-react": true,
    itemScope: true,
    itemType: itemType
  }, React.createElement("meta", {
    content: hasError ? fallbackImageUrl : $noscriptUrl,
    itemProp: "url"
  }), hasError ? React.createElement(Img, null) : React.createElement("picture", null, imagesArray.map(image => {
    const sourceElements = getSourceElementsData(image);
    return sourceElements.map(source => React.createElement("source", {
      key: source.id,
      media: source.media,
      sizes: source.sizes,
      srcSet: source.srcSet
    }));
  }), React.createElement("img", {
    alt: currentAlt,
    className: "js-image image",
    decoding: "sync",
    itemProp: "image",
    loading: loadingLazy ? 'lazy' : 'eager',
    onError: handleError,
    onLoad: handleImageLoad,
    src: !loadingLazy ? defaultImgUrl : null,
    title: currentTitle
  })));
};
svs.content.image_v2.MultiImage = MultiImage;

 })(window);